import * as React from 'react';
import makeAnimated from 'react-select/animated';
import { ISelectableEntity, ISelectOption } from '../../../../data/types';
import { useEntities } from '../../../../hooks/useEntities';
import { Select } from '../Select';

interface IProps {
  value: ISelectOption;
  disabled?: boolean;
  onChange: (s: ISelectableEntity) => void;
  excludedList?: string[];
}

const AthleteSelect = (props: IProps): React.ReactElement => {
  const { athletes, loading } = useEntities();
  const { value, disabled } = props;

  /**
   * @description creates a memoized list of items grouped by team that updates when props update
   */
  const data = React.useMemo((): ISelectableEntity[] => {
    const athleteSelectOptions = [];
    const excludedList = props.excludedList || [];
    for (const athlete of athletes) {
      /// only include athlete's whose ids are not in the excluded list
      /// if excludedList is not provided, all athletes will be included
      if (!excludedList.includes(athlete.id)) {
        athleteSelectOptions.push({
          label: athlete.name,
          value: athlete.id,
          entity: athlete,
        });
      }
    }
    return athleteSelectOptions;
  }, [athletes?.length]);

  const onChange = (opt: ISelectableEntity): void => {
    props.onChange(opt);
  };

  return (
    <Select
      options={data}
      controlShouldRenderValue
      value={value}
      isDisabled={disabled}
      placeholder='Athlete...'
      components={makeAnimated()}
      onChange={onChange}
      cache={false}
      id={'input-select'}
    />
  );
};

export { AthleteSelect };
